const onConsentHandler = () => {
  Array.isArray(window.requireConsent) &&
    window.requireConsent.forEach((cmd) => typeof cmd === 'function' && cmd());
  window.requireConsent = {
    push: function (cmd) {
      if (typeof cmd === 'function') cmd();
    },
  };
};

const openPrivacyPreferences = () => {
  window.requireConsent.push(() => window.__tcfapi('showConsentManager'));
};

const injectLiveRampSdk = (liverampId) => {
  const a = window.document.createElement('script');
  a.type = 'text/javascript';
  a.async = true;
  a.src = `https://gdpr-wrapper.privacymanager.io/gdpr/${liverampId}/gdpr-liveramp.js`;
  const b = window.document.getElementsByTagName('script')[0];
  (b.parentNode || { insertBefore: () => '' }).insertBefore(a, b);
};

const init = (liverampId) => {
  /*
   * Add a global requireConsent queue that will be executed as soon as the user provide her consent.
   */
  if (typeof window !== 'undefined') {
    window.onConsentHandler = onConsentHandler;
    window.requireConsent = window.requireConsent || [];
    injectLiveRampSdk(liverampId);
    // TODO questo deve essere chiamato da GTM all'approvazione del consenso di LiveRamp
    onConsentHandler();
  }
};

export { onConsentHandler, init, openPrivacyPreferences };
